import firebase from 'firebase/compat/app';
import { getFirestore } from  'firebase/firestore';
import { getAuth } from 'firebase/auth'

var firebaseConfig = {
  apiKey: "AIzaSyC-pIf5dnhfOcweF-bQtq7E-GWlkCVa8po",
  authDomain: "construtora-a77b3.firebaseapp.com",
  projectId: "construtora-a77b3",
  storageBucket: "construtora-a77b3.appspot.com",
  messagingSenderId: "336251863385",
  appId: "1:336251863385:web:60bcda57d5f7aa6aeb4c48"
};

const app = firebase.initializeApp(firebaseConfig);

const db = getFirestore()
export const auth = getAuth(app)
export default db;
